export const ServiceDiscounts = {
  panditBookingDiscount: 18,
  DailyBookingDiscount: 18,
  PujaAtTemple: 18,
  darshanBooking: 18
};


export const FaqModuleID = {
  PujaBooking: 1,
  DailyPujaBooking: 2,
  DarshanBooking: 3,
  PujaAtTempleBooking: 4,
  EstoreBooking: 5,
  PrasadBooking: 6
}